import { LocalStorageAdapter } from "@/infrastructure/adapters/localStorage/LocalStorage.adapter";
import { JsonSerializer } from "@/infrastructure/serializers/JsonSerializer";
import {
  DEFAULT_THEME_PREFERENCE,
  THEME_STORAGE_KEY,
  isThemePreference,
  type ThemePreference,
} from "@/core/theme/theme";

class ThemeStateRepository {
  private readonly storage = new LocalStorageAdapter(new JsonSerializer());

  async getPreference(): Promise<ThemePreference> {
    const item = await this.storage.retrieve<ThemePreference>(THEME_STORAGE_KEY);
    return isThemePreference(item?.value) ? item.value : DEFAULT_THEME_PREFERENCE;
  }

  async setPreference(preference: ThemePreference): Promise<void> {
    await this.storage.store({ key: THEME_STORAGE_KEY, value: preference });
  }
}

export const themeStateRepository = new ThemeStateRepository();
